import type { TranslationKey } from "@/i18n";

export const homeStrings = {
  title: "home.title",
  findYourSpace: "home.findYourSpace",
  live: "home.live",
  loadingSpace: "home.loadingSpace",
  visibilityA11y: "home.topBar.visibilityA11y",
  visible: "home.topBar.visible",
  hidden: "home.topBar.hidden",
  visibleHint: "home.topBar.visibleHint",
  hiddenHint: "home.topBar.hiddenHint",
  peopleCount: "home.topBar.peopleCount",
  // The three anchors take a `distance` interpolation — see
  // `nearby-radius-slider.tsx`. The `*Body` descriptions that used to sit
  // beside them are gone: they were left over from the three-chip picker, were
  // rendered nowhere, and one of them described the widest setting as "within
  // walking distance", which stopped being true when the ceiling reached 10 km.
  closeBy: "home.nearbyRange.closeBy",
  nearby: "home.nearbyRange.nearby",
  localArea: "home.nearbyRange.localArea",
  rangeFailed: "home.nearbyRange.updateFailedTitle",
  cueFailed: "home.cue.sendFailedTitle",
  visibilityFailed: "home.visibility.failedTitle",
  shareTitle: "home.share.title",
  shareMessage: "home.share.messageIntro",
  shareFailed: "home.share.failedTitle",
  shareFailedBody: "home.share.failedBody",
  shareCardTitle: "home.share.cardTitle",
  shareCardBody: "home.share.cardBody",
  shareButton: "home.share.button",
  cancelVisibilityA11y: "home.visibilityPrompt.cancelA11y",
  becomeVisibleFirst: "home.visibilityPrompt.title",
  visibilityCueBody: "home.visibilityPrompt.cueBody",
  visibilityGroupBody: "home.visibilityPrompt.groupBody",
  visibilityCueHint: "home.visibilityPrompt.cueVisibleHint",
  visibilityGroupHint: "home.visibilityPrompt.groupVisibleHint",
  visibilityConfirm: "home.visibilityPrompt.confirm",
  currentSpace: "home.venue.currentSpace",
  nearSpace: "home.venue.nearSpace",
  unnamedSpace: "home.venue.unnamedSpace",
  editLocation: "home.venue.edit",
  refreshTitle: "home.venue.refreshTitle",
  refreshBody: "home.venue.refreshBody",
  backendUnavailableTitle: "home.venue.backendUnavailableTitle",
  backendUnavailableBody: "home.venue.backendUnavailableBody",
  offlineTitle: "home.venue.offlineTitle",
  offlineBody: "home.venue.offlineBody",
  locationFailedTitle: "home.venue.locationFailedTitle",
  locationFailedBody: "home.venue.locationFailedBody",
  preciseTitle: "home.venue.preciseTitle",
  preciseBody: "home.venue.preciseBody",
  preciseAction: "home.venue.preciseAction",
  preciseActionA11y: "home.venue.preciseActionA11y",
  peoplePreciseTitle: "home.venue.peoplePreciseTitle",
  peoplePreciseBody: "home.venue.peoplePreciseBody",
  requestFailedTitle: "home.venue.requestFailedTitle",
  requestFailedBody: "home.venue.requestFailedBody",
  retryConnectionA11y: "home.venue.retryConnectionA11y",
  retryConnection: "home.venue.retryConnection",
  retryLocationA11y: "home.venue.retryA11y",
  retryLocation: "home.venue.retry",
  continueAnyway: "home.venue.continueAnyway",
  continueAnywayA11y: "home.venue.continueAnywayA11y",
  peoplePanel: "home.panels.people",
  groupsPanel: "home.panels.smallGroups",
  filter: "home.filters.filter",
  filterCount: "home.filters.filterCount",
  clear: "home.filters.clear",
  clearFilters: "home.filters.clearFilters",
  any: "home.filters.any",
  filterPeopleA11y: "home.filters.peopleA11y",
  clearPeopleA11y: "home.filters.clearPeopleA11y",
  closePeopleA11y: "home.filters.closePeopleA11y",
  filterPeopleTitle: "home.filters.peopleTitle",
  filterPeopleBody: "home.filters.peopleBody",
  nearbyRange: "home.filters.nearbyRange",
  // Same Space: the mode control that replaces the range slider.
  whoToShow: "home.filters.whoToShow",
  modeRadius: "home.filters.modeRadius",
  modeSameSpace: "home.filters.modeSameSpace",
  modeRadiusHint: "home.filters.modeRadiusHint",
  modeSameSpaceHint: "home.filters.modeSameSpaceHint",
  sameSpaceJoin: "home.filters.sameSpaceJoin",
  sameSpaceJoined: "home.filters.sameSpaceJoined",
  sameSpaceFailedTitle: "home.filters.sameSpaceFailedTitle",
  sameSpaceLeaveFailedTitle: "home.filters.sameSpaceLeaveFailedTitle",
  ageRange: "home.filters.ageRange",
  languages: "home.filters.languages",
  friendshipGoal: "home.filters.friendshipGoal",
  closeGroupsA11y: "home.filters.closeGroupsA11y",
  filterGroupsTitle: "home.filters.groupsTitle",
  filterGroupsBody: "home.filters.groupsBody",
  goal: "home.filters.goal",
  groupSize: "home.filters.groupSize",
  anyAge: "home.filters.anyAge",
  peopleOption: "home.filters.peopleOption",
  profileAgeRequired: "home.filters.profileAgeRequired",
  profileLanguagesRequired: "home.filters.profileLanguagesRequired",
  profileGoalRequired: "home.filters.profileGoalRequired",
  groupNameRequired: "home.groups.nameRequiredTitle",
  groupNameRequiredBody: "home.groups.nameRequiredBody",
  groupCreateFailed: "home.groups.createFailedTitle",
  groupLocationRequired: "home.groups.locationRequiredBody",
  groupJoinFailed: "home.groups.joinFailedTitle",
  groupsIntro: "home.groups.intro",
  createGroup: "home.groups.createGroup",
  small: "home.groups.small",
  noGroupsMatch: "home.groups.noMatchesTitle",
  noGroupsMatchBody: "home.groups.noMatchesBody",
  noGroups: "home.groups.noneTitle",
  noGroupsBody: "home.groups.noneBody",
  nearbyGroupsCount: "home.groups.nearbyCount",
  groupCardMeta: "home.groups.cardMeta",
  groupOpen: "home.groups.open",
  groupFull: "home.groups.full",
  groupView: "home.groups.view",
  groupJoinAction: "home.groups.joinAction",
  groupOpenA11y: "home.groups.openA11y",
  groupViewA11y: "home.groups.viewA11y",
  groupJoinA11y: "home.groups.joinA11y",
  cancelCreateA11y: "home.groups.cancelCreateA11y",
  createGroupTitle: "home.groups.createTitle",
  createGroupBody: "home.groups.createBody",
  groupName: "home.groups.name",
  groupNamePlaceholder: "home.groups.namePlaceholder",
  selectGoal: "home.groups.selectGoal",
  customGoalPlaceholder: "home.groups.customGoalPlaceholder",
  customGoalRequired: "home.groups.customGoalRequiredTitle",
  customGoalRequiredBody: "home.groups.customGoalRequiredBody",
  selectSize: "home.groups.selectSize",
  durationQuestion: "home.groups.durationQuestion",
  groupRangeQuestion: "home.groups.rangeQuestion",
  groupRangeHint: "home.groups.rangeHint",
  selectDuration: "home.groups.selectDuration",
  minutes: "home.groups.minutes",
  hours: "home.groups.hours",
  optionalNote: "home.groups.optionalNote",
  notePlaceholder: "home.groups.notePlaceholder",
  create: "home.groups.create",
  cancelJoinA11y: "home.groups.cancelJoinA11y",
  joinTitle: "home.groups.joinTitle",
  joinSummary: "home.groups.joinSummary",
  leaveAnytime: "home.groups.leaveAnytime",
  join: "home.groups.join",
  joinOnly: "home.groups.joinOnly",
  joinAndCue: "home.groups.joinAndCue",
  joinCueHint: "home.groups.joinCueHint",
  peopleEmptyTitle: "home.people.emptyTitle",
  peopleEmptyBody: "home.people.emptyBody",
  peopleWaiting: "home.people.waiting",
  peopleWaitingHere: "home.people.waitingHere",
  noPeopleMatch: "home.people.noMatchesTitle",
  noPeopleMatchBody: "home.people.noMatchesBody",
  openProfileA11y: "home.people.openProfileA11y",
  hereFor: "home.people.hereFor",
  cueSentA11y: "home.people.cueSentA11y",
  sendCueA11y: "home.people.sendCueA11y",
  sent: "home.people.sent",
  cue: "home.people.cue",
  cancel: "common.cancel",
  done: "common.done",
  tryAgain: "common.tryAgain",
  genericError: "errors.tryAgainInAMoment",
} as const satisfies Record<string, TranslationKey>;

export const groupGoalKeys = {
  "Casual Hello": "home.groupGoals.casualHello",
  "Coffee Chat": "home.groupGoals.coffeeChat",
  "Work/Study Break": "home.groupGoals.workStudyBreak",
  "Group Hangout": "home.groupGoals.groupHangout",
  "Try Something New": "home.groupGoals.trySomethingNew",
  "Explore Nearby": "home.groupGoals.exploreNearby",
  "Food & Coffee": "home.groupGoals.foodCoffee",
  "Walk/Fitness": "home.groupGoals.walkFitness",
  "Local Event": "home.groupGoals.localEvent",
  "Low-Pressure Chat": "home.groupGoals.lowPressureChat",
  Other: "home.groupGoals.other",
} as const satisfies Record<string, TranslationKey>;

/** Home discovery, nearby filters, venue status, sharing, and Small Group creation. Stored filter and group-goal values remain untranslated API values; only their labels are localized. */
